import { Link } from "react-router-dom";
import "./Footer.css";

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-section">
        <Link to="/mentions-legales">Mentions Légales</Link>
        <Link to="/contact">Besoin d'aide ? Nous contacter</Link>{" "}
        <Link to="/presentation">La Clinique des 3 Soleils</Link>
      </div>
      <div className="footer-section right-content">
        <p>© Tous droits réservés Clinique des 3 Soleils</p>
      </div>
    </footer>
  );
};

export default Footer;
